import ManageHeader from "@components/ManageHeader";
import React, { useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { UserPlusIcon } from "lucide-react";
import { GoPersonFill } from "react-icons/go";
import { MdBedroomParent } from "react-icons/md";
import { MdPersonAddAlt1 } from "react-icons/md";
import AJXLoader from "@components/AJXLoader";
import LoadError from "@components/LoadError";
import { apiSend, getRoute } from "@services/axios";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Config } from "@config/config";
import { Button } from "rsuite";
import { useModal } from "@components/ModalContext";
import { saveChangeTypePriceRoom } from "./Actions";

import FormTypePrice from "./forms/FormTypePrice";
const queryClient = new QueryClient();

function OccupancyAndFees(props) {
  const { t } = useTranslation();
  const config = new Config(t);

  return (
    <>
      <ManageHeader
        title={t("")}
        content={t("ho_act_frais_ind_txt")}
        icon={<UserPlusIcon size={25} strokeWidth={1.5} />}
      />
      <QueryClientProvider client={queryClient}>
        <DataRoom t={t} {...props} config={config} />
      </QueryClientProvider>
    </>
  );
}

export default OccupancyAndFees;

function DataRoom(props) {
  const t = props.t;
  const config = props.config;
  const id = useParams().id;
  const paramUseModal = useModal();
  const [rooms, setRooms] = useState([]);
  const [priceType, setPriceType] = useState(null);
  const myRef = useRef();
  const load = async () => {
    const response = await apiSend(
      [getRoute("PRODUCT_RETRIEVE"), id, "rooms"].join("/"),
      "get"
    );
    if (response?.data?.request?.status === true) {
      setRooms(response?.data?.result?.rooms);
      setPriceType(response?.data?.result?.pricingType);
    }

    return response?.data?.request?.status;
  };

  const { isLoading, error } = useQuery("repoData", () => load());
  if (isLoading) return <AJXLoader />;
  if (error) return <LoadError message={t("not_found")} />;

  const handleChangeTypePrice = (room, index) => {
    paramUseModal.setSize("md");
    paramUseModal.setTitle(room.type + " " + room.option);
    paramUseModal.openModal(
      <FormTypePrice
        productId={id}
        room={room}
        index={index}
        changeTypePrice={changeTypePrice}
      />
    );
  };

  const changeTypePrice = async (room, index, priceType) => {
    const res = await saveChangeTypePriceRoom(id, room.id, priceType);
    paramUseModal.closeModal();
    if (res === true) {
      room.priceType = priceType;
      rooms[index] = room;
    }
  };

  return (
    <div>
      <div className="container my-4">
        <Row className="bgperson">
          <Col xl="6">
            <div className="d-flex flex-row">
              <div className="content ms-2 mt-4">
                <div className="fs-2 fw-bold text-dark my-4">
                  {t("ho_act_frais_ind_chambre")}
                </div>
                <div>
                  <span className="" style={{ color: "#333333" }}>
                    {t("ho_act_frais_ind_chambre_txt")}
                  </span>
                </div>
                <div className="mt-4">
                  <Button
                    appearance="primary"
                    color="cyan"
                    className="px-5 fw-medium"
                  >
                    <span
                      className="text-white"
                      onClick={() =>
                        myRef.current?.scrollIntoView({
                          behavior: "smooth",
                        })
                      }
                    >
                      {t("ho_act_frais_ind_btw")}
                    </span>
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="container">
        <Row className="my-3">
          <Col md="6" lg="4" className="my-2 p-1">
            <div className="bg-white border rounded p-3 h-100">
              <div className="d-flex justify-content-between">
                <div className="">
                  <div className="text-dark fs-4 fw-bold mb-4 py-2">
                    {t("ho_act_frais_parPerson")}
                  </div>
                  <div className="fs-7 text-dark my-2">
                    {t("ho_act_frais_parPersonTxt")}
                  </div>
                </div>
                <div>
                  <GoPersonFill
                    className="text-orange"
                    style={{
                      width: "80px",
                      height: "80px",
                      color: "lightblue",
                    }}
                  />
                </div>
              </div>
            </div>
          </Col>
          <Col md="6" lg="4" className="my-2 p-1">
            <div className="bg-white border rounded p-3 h-100">
              <div className="d-flex justify-content-between">
                <div>
                  <div className="text-dark fs-4 fw-bold mb-4 py-2">
                    {t("ho_act_frais_parRoom")}
                  </div>
                  <div className="fs-7 text-dark my-2">
                    {t("ho_act_frais_ind_room_txt")}
                  </div>
                </div>
                <div>
                  <MdBedroomParent
                    className="text-green"
                    style={{ width: "80px", height: "80px" }}
                  />
                </div>
              </div>
            </div>
          </Col>
          <Col md="6" lg="4" className="my-2 p-1">
            <div className="bg-white border rounded p-3 h-100">
              <div className="d-flex justify-content-between">
                <div>
                  <div className="fs-4 fw-bold text-dark">
                    {t("ho_act_frais_ind_fraisPlus")}
                  </div>
                  <div className="fs-7 text-dark my-2">
                    {t("ho_act_frais_ind_fraisPlusTxt")}
                  </div>
                </div>
                <div>
                  <MdPersonAddAlt1
                    className="text-blue"
                    style={{ width: "80px", height: "80px", color: "orange" }}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="container mt-2" ref={myRef}>
        {config.priceType(priceType)}
        <span className="text-capitalize text-dark fs-4 fw-bold mx-2">
          {t("activate")}
        </span>
        <div className="d-flex align-items-center mt-2">
          <p className="fs-8 w-75">{t("ho_act_frais_ind_ActivéTXT")}</p>
        </div>
      </div>
      <div className="container mt-2">
        <Row>
          {rooms.map((room, rowIndex) => (
            <Col md="6" lg="6" className="p-1" key={rowIndex}>
              <div className="bg-white border rounded p-3 h-100">
                <div className="d-flex justify-content-between">
                  <div>
                    <div className="fs-5 fw-bold text-dark">
                      <Button
                        color={props.config.statusColor(room.status)}
                        appearance="primary"
                      ></Button>{" "}
                      {room.type} {room.option}
                    </div>
                    <div className="d-flex flex-row">
                      <div className="fs-7 text-dark my-2 d-flex flex-column">
                        <span>{t("ho_act_detailscancelTarif")}</span>
                        <span>
                          {config.priceType(
                            room?.priceType === "" ? priceType : room?.priceType
                          )}
                        </span>
                      </div>
                      <div className="d-flex justify-content-center mt-5 ms-5 ps-5">
                        <Button
                          color="blue"
                          appearance="primary"
                          onClick={() => handleChangeTypePrice(room, rowIndex)}
                        >
                          {t("edit")}
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div>
                    {config.priceTypeIcon(
                      room?.priceType === "" ? priceType : room?.priceType
                    )}
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}
